
import 'pages/products/products/products-list.tag'
import 'pages/products/products/product-edit.tag'
import 'pages/products/groups/groups-list.tag'
import 'pages/products/groups/group-edit.tag'
import 'pages/products/brands/brands-list.tag'
import 'pages/products/brands/brand-edit.tag'
import 'pages/products/parameters/parameters.tag'
import 'pages/products/modifications/modifications-list.tag'
import 'pages/products/modifications/modification-edit.tag'
import 'pages/products/discounts/discounts-list.tag'
import 'pages/products/discounts/discount-edit.tag'
import 'pages/products/coupons/coupons-list.tag'
import 'pages/products/coupons/coupon-edit.tag'
import 'pages/products/products-types/products-types-list.tag'
import 'pages/products/parameters/parameter-edit.tag'
import 'pages/products/options/options.tag'
import 'pages/delivery/delivery.tag'
import 'pages/delivery/delivery-edit.tag'
import 'pages/products/labels/labels-list.tag'
import 'pages/products/labels/label-edit.tag'
riot.tag2('products', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="{active: name == tab}" each="{tabs}" title="{title}" if="{access}"><a href="#products/{link}"><i class="{icon}"></i><span class="hidden-xs">&nbsp;{title}</span></a></li>\n  </ul>\n  <div class="column">\n    <products-list if="{tab == &quot;products&quot; &amp;&amp; !edit}"></products-list>\n    <product-edit if="{tab == &quot;products&quot; &amp;&amp; edit}"></product-edit>\n    <groups-list if="{tab == &quot;categories&quot; &amp;&amp; !edit}"></groups-list>\n    <group-edit if="{tab == &quot;categories&quot; &amp;&amp; edit}"></group-edit>\n    <labels-list if="{tab == &quot;labels&quot; &amp;&amp; !edit}"></labels-list>\n    <label-edit if="{tab == &quot;labels&quot; &amp;&amp; edit}"></label-edit>\n    <products-types-list if="{tab == &quot;types&quot; &amp;&amp; !edit}"></products-types-list>\n    <brands-list if="{tab == &quot;brands&quot; &amp;&amp; !edit}"></brands-list>\n    <brand-edit if="{tab == &quot;brands&quot; &amp;&amp; edit}"></brand-edit>\n    <options if="{tab == &quot;options&quot;}"></options>\n    <parameters if="{tab == &quot;parameters&quot; &amp;&amp; !edit}"></parameters>\n    <parameter-edit if="{tab == &quot;parameters&quot; &amp;&amp; edit}"></parameter-edit>\n    <modifications-list if="{tab == &quot;modifications&quot; &amp;&amp; !edit}"></modifications-list>\n    <modification-edit if="{tab == &quot;modifications&quot; &amp;&amp; edit}"></modification-edit>\n    <discounts-list if="{tab == &quot;discounts&quot; &amp;&amp; !edit}"></discounts-list>\n    <discount-edit if="{tab == &quot;discounts&quot; &amp;&amp; edit}"></discount-edit>\n    <delivery if="{tab == &quot;delivery&quot; &amp;&amp; !edit}"></delivery>\n    <delivery-edit if="{tab == &quot;delivery&quot; &amp;&amp; edit}"></delivery-edit>\n    <coupons-list if="{tab == &quot;coupons&quot; &amp;&amp; !edit}"></coupons-list>\n    <coupon-edit if="{tab == &quot;coupons&quot; &amp;&amp; edit}"></coupon-edit>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;

self.edit = false;
self.tab = '';
self.app = app;
self.bigaccess = self.app.config.version > 530;

self.tabs = [{ title: 'Список товаров', name: 'products', link: '', icon: 'fa fa-shopping-bag', access: true }, { title: 'Категории', name: 'categories', link: 'categories', icon: 'fa fa-folder-open', access: true }, { title: 'Бренды', name: 'brands', link: 'brands', icon: 'fa fa-adn', access: true }, { title: 'Ярлыки', name: 'labels', link: 'labels', icon: 'fa fa-tags', access: true }, { title: 'Опции', name: 'options', link: 'options', icon: 'fa fa-list', access: true }, { title: 'Параметры', name: 'parameters', link: 'parameters', icon: 'fa fa-cog', access: true }, { title: 'Характеристики', name: 'types', link: 'types', icon: 'fa fa-check-square', access: true }, { title: 'Модификации', name: 'modifications', link: 'modifications', icon: 'fa fa-sliders', access: true }, { title: 'Доставка', name: 'delivery', link: 'delivery', icon: 'fa fa-truck', access: true }, { title: 'Скидки', name: 'discounts', link: 'discounts', icon: 'fa fa-percent', access: true }, { title: 'Купоны', name: 'coupons', link: 'coupons', icon: 'fa fa-money', access: true }];

var route = riot.route.create();

route('/products/([0-9]+)', function (id) {
    self.tab = 'products';
    observable.trigger('products-edit', id);
    self.edit = true;
    self.update();
});

route('/products/*/([0-9]+)', function (tab, id) {
    if (self.tabs.map(function (i) {
        return i.name;
    }).indexOf(tab) !== -1) {
        self.update({ edit: true, tab: tab });
        observable.trigger(tab + '-edit', id);
    } else {
        self.update({ edit: true, tab: 'not-found' });
        observable.trigger('not-found');
    }
});

route('/products/multi..', function () {
    var q = riot.route.query();
    var ids = q.ids.split(',');
    self.tab = 'products';
    observable.trigger('products-multi-edit', ids);
    self.edit = true;
    self.update();
});

route('/products/clone..', function () {
    var q = riot.route.query();
    var id = q.id;
    self.tab = 'products';
    observable.trigger('products-clone', id);
    self.edit = true;
    self.update();
});

route('/products/categories/multi..', function () {
    var q = riot.route.query();
    var ids = q.ids.split(',');
    self.tab = 'categories';
    observable.trigger('categories-multi-edit', ids);
    self.edit = true;
    self.update();
});

route('/products/labels/new', function (tab) {
    self.update({ edit: true, tab: 'labels' });
    observable.trigger('label-new');
});

route('/products/modifications/new', function (tab) {
    self.update({ edit: true, tab: 'modifications' });
    observable.trigger('modifications-new');
});

route('/products/discounts/new', function (tab) {
    self.update({ edit: true, tab: 'discounts' });
    observable.trigger('discounts-new');
});

route('/products/coupons/new', function (tab) {
    self.update({ edit: true, tab: 'coupons' });
    observable.trigger('coupons-new');
});

route('/products', function () {
    self.edit = false;
    self.tab = 'products';
    self.update();
});

route('/products/*', function (tab) {
    if (self.tabs.map(function (i) {
        return i.name;
    }).indexOf(tab) !== -1) {
        self.update({ edit: false, tab: tab });
    } else {
        self.update({ edit: true, tab: 'not-found' });
        observable.trigger('not-found');
    }
});

route('/products..', function () {
    self.update({ edit: true, tab: 'not-found' });
    observable.trigger('not-found');
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/products/products.tag